
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20.042","height":"20.138"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1219.107 -374.807)","fill":"none","stroke":"#869398","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"width":"6.5","height":"6.5","rx":"1.867","transform":"rotate(180 616.189 190.904)"}}),_c('line',{attrs:{"y1":"1.892","transform":"translate(1229.128 381.845)"}}),_c('rect',{attrs:{"width":"6.5","height":"6.5","rx":"1.867","transform":"rotate(-180 613.053 197.222)"}}),_c('line',{attrs:{"y1":"1.892","transform":"translate(1222.857 385.451)"}}),_c('rect',{attrs:{"width":"6.5","height":"6.5","rx":"1.867","transform":"rotate(-180 619.324 197.222)"}}),_c('line',{attrs:{"y1":"1.892","transform":"translate(1235.4 385.451)"}}),_c('line',{attrs:{"x1":"12.522","transform":"translate(1222.877 385.451)"}})])])
          )
        }
      }
    